module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAPdJREFUSA3tVt0JwjAQ/q4Ed3AWN7BvDuAaQisiYkXX8N037QpuoksUz0valBBMsbUKioW011zu/8J3hCUPUGAFxlTWEMAZGUYgYqGBlE+yPza0/yLkyCiutxM+CD0B4SprD4WFMspvmNWH2hGlE76MdpRFZwGxk/LFeB4hxppy/2yn/4R1VEcdCSHh0osNUSdlIaFKbxTi97X//QZUMBVN7ekL+e3q8PtK0eN2FUPhCNwL5HjUluwrgqDdcAT/GlRJ+9fAds8P34O3F/kDBjRA66eEOVu0175Wl4HMOW/RHfSbHYmwU3q00OgvwG/HlmahZ7jO2HIHzXBK4dHWJkUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-ckdh.png
// module id = 420
// module chunks = 2